import { BASE_ACTION_TYPE } from 'api/types';
import { JourneyIconButton } from 'ui/journey-builder/node-types/common';
import { JourneyNode } from 'ui/journey-builder/node-types/types';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

type JourneyStartProps = {
  node: JourneyNode<BASE_ACTION_TYPE> | TravellerJourneyNode<BASE_ACTION_TYPE>;
  cursor?: 'pointer' | 'default';
  onIconClick?: () => void;
};

export const JourneyStart = ({ node, cursor, onIconClick }: JourneyStartProps) => {
  return (
    <JourneyIconButton node={node} color="elementGreen100" cursor={cursor} onClick={onIconClick} />
  );
};
